import { render } from "./Saffron.vue?vue&type=template&id=4a250cfb"
import script from "./Saffron.vue?vue&type=script&lang=js"
export * from "./Saffron.vue?vue&type=script&lang=js"

import "./Saffron.vue?vue&type=style&index=0&id=4a250cfb&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__